require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./langues-denseignement-2-6-5.json") })
        }
      }, "path---langues-denseignement-2-6-5");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---langues-denseignement-2-6-5!./.cache/json/langues-denseignement-2-6-5.json
// module id = 473
// module chunks = 231608221292675